import type { Island, Kitchen } from '@rta/rta-blueprint-library';

import { getSortedIslands } from './get-sorted-islands';

export type GetIslandSuffixParams = {
	island: Island;
	kitchen: Kitchen;
	islandDescriptionCache?: string;
};

/**
 * Returns the alphabetical letter (A, B, C, ...) assigned to this island in
 * a multi-island kitchen. Order is strictly left-to-right by world-space
 * position (`origin.x`, with `origin.z` as tiebreaker) so the letters match
 * the visual overhead layout: A is always the leftmost island, Z the rightmost.
 *
 * Returns an empty string for single-island kitchens (no prefix needed).
 *
 * Per the 2025+ PDF blueprint convention, every island in a multi-island kitchen
 * receives a letter — regardless of whether names collide.
 */
export const getIslandSuffix = (params: GetIslandSuffixParams): string => {
	const { island, kitchen } = params;
	const { islands } = kitchen.design;

	if (islands.children.length <= 1) return '';

	const sorted = getSortedIslands(islands.children);
	const index = sorted.findIndex((i) => i.id === island.id);
	if (index < 0) return '';

	return String.fromCharCode(65 + index);
};
